import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { TinhTrangMSXK } from 'src/app/shared/TinhTrangMSXK.model';
import { BaseService } from './Base.service';
@Injectable({
    providedIn: 'root'
})
export class TinhTrangMSXKService extends BaseService{
    constructor(public httpClient: HttpClient) {
        super(httpClient);
        this.Controller = "TinhTrangMSXK";
    }
}

